module.exports = __webpack_public_path__ + "static/img/sign-1.3c175b1c.png";